import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var GitMerge = createReactComponent("GitMerge", ["svg", defaultAttributes, [["circle", {
  cx: "18",
  cy: "18",
  r: "3",
  key: "1p0y38"
}], ["circle", {
  cx: "6",
  cy: "6",
  r: "3",
  key: "ey9bbu"
}], ["path", {
  d: "M6 21V9a9 9 0 009 9",
  key: "16n2ug"
}]]]);
export default GitMerge;